import { MouseEvent, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader, Pagination, Text } from "@findemdev/maui";
import { decodeString } from "@findemdev/findem-helpers";
import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';
// types
import { ICredential } from "../../types/credential";
// styled components + components
import { Detail, EmptyState, FooterSection, Grid, GridContent, GridItem, LoaderContainer, Wrapper } from "./CredentialsGrid.styled";
// assets
import StandardTemplate from "../../assets/CredentialTemplates/standard.svg";

dayjs.extend(relativeTime);

interface ICredentialsGrid {
  pageNumber: number;
  data: ICredential[];
  total: number;
  pageSize: number;
  isPending: boolean;
  handlePageChange: (page: number, pageSize: number) => void;
}

const CredentialsGrid = ({
  pageNumber,
  data,
  total,
  pageSize,
  isPending,
  handlePageChange,
}: ICredentialsGrid
) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Callback
  const handleCredClick = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      const target = event.currentTarget as HTMLElement;
      const credId = target.getAttribute("data-cred-id") ?? undefined;
      navigate(`credentials/${credId}?${searchParams.toString()}`);
    },
    [navigate, searchParams]
  );

  return (
    <Wrapper>
      <GridContent>
        {!isPending ?
          data.length ?
            <Grid>
            {data.map((datum) => {
              return <GridItem key={datum.ref} data-cred-id={datum.ref} onClick={handleCredClick}>
                <img src={StandardTemplate as unknown as string} alt="" />
                <Detail>
                  <Text variant="boldData">{decodeString(datum.name)}</Text>
                  <Text variant="detail" options={[ 'muted' ]}>
                    {datum.client_company_name ? `${datum.client_company_name} • ` : ""}{datum.updated_at &&
                    dayjs(datum.updated_at).fromNow()}
                  </Text>
                </Detail>
            </GridItem>
            })}
            </Grid>
            :
            <EmptyState variant="defaultHeader">No Credentials found</EmptyState>
          :
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        }
      </GridContent>
      {!isPending && data.length &&
        <FooterSection>
          <Pagination
            total={total}
            pageSize={pageSize}
            current={pageNumber + 1}
            onChange={handlePageChange}
          />
        </FooterSection>
      }
    </Wrapper>
  );
};

export default CredentialsGrid;
